/* Panelin veri deposu.
   Sunucu tanımlıysa oraya yazar; değilse tarayıcıda tutar.
   Böylece sunucu kurulmadan da panel çalışır, kurulunca kendiliğinden geçer. */

const ANAHTAR = "karelias:v4";
const SUNUCU = import.meta.env.VITE_API_URL || "";

const jeton = () => localStorage.getItem("karelias:jeton") || "";

async function sunucuIstek(yol, secenek = {}) {
  const r = await fetch(`${SUNUCU.replace(/\/$/, "")}${yol}`, {
    ...secenek,
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + jeton(), ...(secenek.headers || {}) },
  });
  if (r.status === 401) { localStorage.removeItem("karelias:jeton"); location.reload(); return null; }
  if (!r.ok) throw new Error("Sunucu " + r.status);
  return r.json();
}

export const depo = {
  async oku() {
    if (SUNUCU && jeton()) {
      try {
        const c = await sunucuIstek("/api/panel-durum");
        if (c && c.veri) return c.veri;
      } catch (e) { console.warn("Sunucudan okunamadı, yerel kopya kullanılıyor:", e.message); }
    }
    const y = localStorage.getItem(ANAHTAR);
    return y ? JSON.parse(y) : null;
  },

  async yaz(veri) {
    localStorage.setItem(ANAHTAR, JSON.stringify(veri)); // her hâlükârda yerel kopya
    if (SUNUCU && jeton()) {
      try { await sunucuIstek("/api/panel-durum", { method: "POST", body: JSON.stringify({ veri }) }); }
      catch (e) { console.warn("Sunucuya yazılamadı, yerelde tutuldu:", e.message); }
    }
  },

  async giris(parola) {
    if (!SUNUCU) { localStorage.setItem("karelias:jeton", "yerel"); return true; }
    const r = await fetch(`${SUNUCU.replace(/\/$/, "")}/api/giris`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ parola }),
    });
    if (!r.ok) return false;
    const { jeton: j } = await r.json();
    localStorage.setItem("karelias:jeton", j);
    return true;
  },

  cikis() { localStorage.removeItem("karelias:jeton"); },
  girisliMi: () => !!jeton(),
  sunucuVar: () => !!SUNUCU,
};
